import { useCallback } from 'react';

import type { GlobalShortcutsItem } from '@atlassian/global-shortcuts';

import type { NavItemConfig } from '../../../../common/types';
import { getMenuIconAndLabel } from '../../../../common/utils/get-menu-icon-and-label';

export const useGetMenuIconAndLabel = (
	items: Record<string, NavItemConfig>,
	shortcuts: Record<string, GlobalShortcutsItem>,
) =>
	useCallback(
		(menuId: string) => getMenuIconAndLabel(items, shortcuts)(menuId),
		[items, shortcuts],
	);
